import { i18n } from "@/main";

export default [
  {
    tag: "title",
    example: "{title: Title of Song}",
    description: i18n.t('R.MES_CSE_TagDescription_Title'),
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: true,
      appearsAfterTag: null,
      mustBeInMetaData: true,
      inputRequired: true,
      overwrittenDuringEditing: true,
      singleUseOnly: true,
      removedOnExport: false
    }
  },
  {
    tag: "footer",
    example: "{footer: Extra text that goes in the footer}",
    description: i18n.t('R.MES_CSE_TagDescription_Footer'),
    rules: {
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: true,
      appearsAfterTag: null,
      mustBeInMetaData: false,
      inputRequired: true,
      overwrittenDuringEditing: true,
      singleUseOnly: true,
      removedOnExport: false
    }
  },
  {
      tag: "ccli",
      example:"{ccli: 12312312}",
      description:"The CCLI Song number assigned.",
      rules:{
        extraTextIsValidKey: false,
        required: false,
        existsOnOwnLine: true,
        appearsAfterTag: null,
        mustBeInMetaData: true,
        inputRequired: true,
        overwrittenDuringEditing: true,
        singleUseOnly: true,
        removedOnExport: false
      }
  },
  {
      tag: "ccli_license",
      example:"{ccli_license: 1241243",
      description:"The CCLI License number that shows up for a user using this chord sheet. ",
      rules:{
        extraTextIsValidKey: false,
        required: false,
        existsOnOwnLine: true,
        appearsAfterTag: null,
        mustBeInMetaData: true,
        inputRequired: true,
        overwrittenDuringEditing: true,
        singleUseOnly: true,
        removedOnExport: false
      }
  },
  {
      tag: "copyright",
      example:"",
      description:"Text that describes the copyright details of the song that will be auto-generated later.",
      rules:{
        extraTextIsValidKey: false,
        required: false,
        existsOnOwnLine: true,
        appearsAfterTag: null,
        mustBeInMetaData: true,
        inputRequired: true,
        overwrittenDuringEditing: true,
        singleUseOnly: true,
        removedOnExport: false
      }

  },

  {
    tag: "author",
    example: "{author: Name1, Name 2, Name x}",
    description: "When exported, \"author\" is changed to \"artist\" for comptability.",
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: true,
      appearsAfterTag: null,
      mustBeInMetaData: true,
      inputRequired: true,
      overwrittenDuringEditing: true,
      singleUseOnly: false
    }
  },
  {
    tag: "key",
    example: "{key: G}",
    description: i18n.t('R.MES_CSE_TagDescription_Key'),
    rules:{
      extraTextIsValidKey: true,
      required: true,
      existsOnOwnLine: true,
      appearsAfterTag: null,
      mustBeInMetaData: true,
      inputRequired: true,
      overwrittenDuringEditing: false,
      singleUseOnly: true,
      removedOnExport: false
    }
  },
  {
    tag: "tempo",
    example: "{tempo: 100}",
    description: i18n.t('R.MES_CSE_TagDescription_Tempo'),
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: true,
      appearsAfterTag: null,
      mustBeInMetaData: true,
      inputRequired: true,
      overwrittenDuringEditing: false,
      singleUseOnly: true,
      removedOnExport: false
    }
  },
  {
    tag: "time",
    example: "{time: 4/4}",
    description: i18n.t('R.MES_CSE_TagDescription_Time'),
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: true,
      appearsAfterTag: null,
      mustBeInMetaData: true,
      inputRequired: true,
      overwrittenDuringEditing: false,
      singleUseOnly: true,
      removedOnExport: false
    }
  },
  {
    tag: "keychange",
    example: "{keychange: A}",
    description: i18n.t('R.MES_CSE_TagDescription_Keychange'),
    rules:{
      extraTextIsValidKey: true,
      required: false,
      existsOnOwnLine: false,
      appearsAfterTag: null,
      mustBeInMetaData: false,
      inputRequired: true,
      overwrittenDuringEditing: false,
      singleUseOnly: false,
      removedOnExport: false
    }
  },
  {
    tag: "flow",
    example: "{flow: C V1 C V2 B C}",
    description: i18n.t('R.MES_CSE_TagDescription_Flow'),
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: true,
      appearsAfterTag: null,
      mustBeInMetaData: false,
      inputRequired: true,
      overwrittenDuringEditing: false,
      singleUseOnly: true,
      removedOnExport: false
    }
  },
  {
    tag: "comment",
    example: "{comment: Verse 1}",
    description: i18n.t('R.MES_CSE_TagDescription_Comment'),
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: false,
      appearsAfterTag: null,
      mustBeInMetaData: false,
      inputRequired: true,
      overwrittenDuringEditing: false,
      singleUseOnly: false,
      removedOnExport: false
    }
  },
  {
    tag: "direction",
    example: "{direction: Repeat twice}",
    description: i18n.t('R.MES_CSE_TagDescription_Direction'),
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: false,
      appearsAfterTag: null,
      mustBeInMetaData: false,
      inputRequired: true,
      overwrittenDuringEditing: false,
      singleUseOnly: false,
      removedOnExport: true
    }
  },
  {
    tag: "column_break",
    example: "{column_break}",
    description: i18n.t('R.MES_CSE_TagDescription_ColumnBreak'),
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: false,
      appearsAfterTag: null,
      mustBeInMetaData: false,
      inputRequired: false,
      overwrittenDuringEditing: false,
      singleUseOnly: false,
      removedOnExport: true
    }
  },
  {
    tag: "line_wrap",
    example: "{line_wrap}",
    description: i18n.t('R.MES_CSE_TagDescription_LineWrap'),
    rules:{
      extraTextIsValidKey: false,
      required: false,
      existsOnOwnLine: false,
      appearsAfterTag: null,
      mustBeInMetaData: false,
      inputRequired: false,
      overwrittenDuringEditing: false,
      singleUseOnly: false,
      removedOnExport: true
    }
  }
]
